import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, PhoneIcon } from 'lucide-react';
interface FinalCTAProps {
  onCtaClick: () => void;
}
export function FinalCTA({
  onCtaClick
}: FinalCTAProps) {
  return <section className="w-full py-20 lg:py-24 bg-gradient-to-br from-brand-navy via-brand-deep to-brand-navy relative overflow-hidden" data-id="element-97">
      <div className="absolute inset-0" data-id="element-98">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-gold/20 rounded-full blur-3xl" data-id="element-99" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-brand-primary/20 rounded-full blur-3xl" data-id="element-100" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-102">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/20 rounded-full mb-6" data-id="element-103">
            <PhoneIcon className="w-4 h-4 text-brand-gold" data-id="element-104" />
            <span className="text-brand-gold font-semibold text-xs sm:text-sm uppercase tracking-wider" data-id="element-105">
              Ready to Begin?
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight" data-id="element-106">
            Request a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary via-brand-gold to-brand-primary" data-id="element-107">
              Medical Appointment
            </span>
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-white/80 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-108">
            Submit an appointment request with Dr. Mark Joy, MD. All
            appointments are scheduled and confirmed by a medical coordinator.
          </p>

          <motion.button onClick={onCtaClick} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="group inline-flex items-center gap-2 sm:gap-3 px-6 py-3.5 sm:px-8 sm:py-4 md:px-10 md:py-5 bg-gradient-to-r from-lime-400 to-lime-500 text-gray-900 font-bold text-base sm:text-lg md:text-xl rounded-full transition-all duration-300 shadow-2xl shadow-lime-400/60 hover:shadow-lime-400/80" aria-label="Submit appointment request" data-id="element-109">
            <span className="whitespace-nowrap" data-id="element-110">
              Submit Appointment Request
            </span>
            <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 transition-transform duration-300 group-hover:translate-x-1 flex-shrink-0" data-id="element-111" />
          </motion.button>

          <p className="text-white/60 text-xs sm:text-sm mt-4 sm:mt-6" data-id="element-112">
            Professional • Confidential • Coordinator-Scheduled
          </p>
        </motion.div>
      </div>
    </section>;
}